import lazysizes from 'lazysizes';
import 'lazysizes/plugins/noscript/ls.noscript';
import ComponentHelper from './components/00_utilities/helpers/ComponentHelper';
import LinkFocusHelper from './components/00_utilities/helpers/LinkFocusHelper';
import ScrollToHelper from './components/00_utilities/helpers/ScrollToHelper';
import CookieHelper from './components/00_utilities/helpers/CookieHelper';
import YoutubeHelper from './components/00_utilities/helpers/YoutubeHelper';

// Global passive event listener override for Lighthouse performance warning
// Based on community solution: https://github.com/kenwheeler/slick/pull/3422
// This ensures Slick's internal event listeners are passive for better performance
if (typeof window !== 'undefined') {
    const originalAddEventListener = EventTarget.prototype.addEventListener;

    EventTarget.prototype.addEventListener = function addEventListenerOverride(type, listener, options) {
        // Check if this is a touch/wheel event and if we're likely in a slider context
        if (['touchstart', 'touchmove', 'touchend', 'wheel', 'mousewheel'].includes(type)) {
            // Make the event passive if it's not explicitly set to prevent default
            let passiveOptions;
            if (typeof options === 'boolean') {
                passiveOptions = { capture: options, passive: true };
            } else if (typeof options === 'object' && options !== null) {
                passiveOptions = { ...options, passive: options.passive !== false };
            } else {
                passiveOptions = { passive: true };
            }

            return originalAddEventListener.call(this, type, listener, passiveOptions);
        }

        // For all other events, use original behavior
        return originalAddEventListener.call(this, type, listener, options);
    };
}

const componentHelper = new ComponentHelper();

/* eslint-disable */
const __svg__ = { path: './svg/*.svg', name: 'Icons/icons.svg', filename: svgFileName };
require('webpack-svgstore-plugin/src/helpers/svgxhr')(__svg__);

if (__devMode__) {
    __webpack_public_path__ = 'http://localhost:8085/assets/';
}
/* eslint-enable */

window.addEventListener('load', () => {
    window.youtubePlayers = [];

    componentHelper.initializePage();
    LinkFocusHelper.handleHashLink();
    ScrollToHelper.initializeAnchorLinks(lazysizes);

    // initialize marketing cookie behaviour for Youtube
    const customEventsOnMarketingAccept = [
        'consent-type-youtube',
        'consent-type-google-maps',
    ];
    CookieHelper.addMarketingCookieListener(customEventsOnMarketingAccept);
    YoutubeHelper.addYoutubeConsentListener();
});

/**
 * Check for hot module replacement and use it if possible
 */
if (module.hot) {
    module.hot.accept();
}
